import styled from "@emotion/styled";
export const StyledMondayDemoTabsAsset = styled.div`
  position: absolute;
  opacity: 0;
  top: 0;
  width: 100%;
  &.current {
    opacity: 1;
  }
`;
